import { useFormContext } from 'react-hook-form'

import { FormError, InputWithDropdown } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface PriceFormatFormFieldProps {}

export const PriceFormatFormField: React.FC<PriceFormatFormFieldProps> = ({}) => {
  const { control, register, setValue } = useFormContext<{ price_format: string; price: number }>()
  return (
    <FormField
      name="price_format"
      control={control}
      render={({ field: priceType }) => (
        <FormField
          name="price"
          control={control}
          render={() => {
            return (
              <FormItem>
                <div className="flex items-center gap-2">
                  <FormLabel>Price</FormLabel>
                  <FormError />
                </div>
                <InputWithDropdown
                  numberInput={{
                    thousandSeparator: ',',
                    placeholder: 'Price',
                    allowNegative: true,
                    ...register('price', {}),
                  }}
                  select={{
                    selectProps: {
                      defaultValue: 'decimal',
                      value: priceType.value,
                      onValueChange: (val) =>
                        setValue('price_format', val as typeof priceType.value, {
                          shouldValidate: true,
                        }),
                    },
                    options: [
                      { value: 'decimal', children: 'decimal' },
                      { value: 'percent', children: 'percent' },
                    ],
                  }}
                />
              </FormItem>
            )
          }}
        />
      )}
    />
  )
}
